export default "__VITE_ASSET__f092582a__"